import React, { useEffect, useState } from "react";
import CardComponent from "../cardComponents/CardComponent";
import AccordionComponent from "../accordion/AccordionComponent";
// import { CreditCardData } from './CardData'
import Http from "../../Http";
import { CARD_API } from "../../Helper";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import {
  FaUserCheck,
  FaIdCard,
  FaExternalLinkAlt,
  FaListAlt,
  FaCheckCircle,
} from "react-icons/fa";
import FAQSchema from "../../FAQSchema";
import { BadgeCheck, FileText } from "lucide-react";
import AdBanner from "../AdPage/AdBanner";
const ICICI = () => {
  const [CreditCardData, setCreditCardData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [cardsPerPage] = useState(10);
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };
  function Icon({ id, open }) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="currentColor"
        className={`${
          id === open ? "rotate-180" : ""
        } h-5 w-5 transition-transform`}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M19.5 8.25l-7.5 7.5-7.5-7.5"
        />
      </svg>
    );
  }
  useEffect(() => {
    Http.post(CARD_API)
      .then((res) => {
        setCreditCardData(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  console.log({ indexOfLastCard, indexOfFirstCard });
  // const currentCards = CreditCardData.cards?.filter((card)=>card.category==="Credit card").slice(indexOfFirstCard, indexOfLastCard);
  // console.log({currentCards})
  const currentCards = CreditCardData.cards
    ?.filter((card) => card.title?.toLowerCase().includes("icici"))
    .slice(indexOfFirstCard, indexOfLastCard);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const faqs = [
    {
      question: "Which is the most popular ICICI credit card?",
      answer:
        "  The ICICI Amazon Pay Credit Card and Coral Credit Card are among the most widely used, offering rewards and cashback across everyday spending categories.",
    },
    {
      question: "Are ICICI credit cards internationally accepted?",
      answer:
        "   Yes, ICICI cards are globally accepted and compatible with Visa, Mastercard, or American Express payment networks, depending on the card variant.",
    },
    {
      question: "Do ICICI credit cards come with lounge access?",
      answer:
        "Select ICICI credit cards, like the Coral, Rubyx, and Sapphiro, offer free domestic and international airport lounge access based on usage and card type.",
    },
    {
      question: "Is there a lifetime free credit card from ICICI Bank?",
      answer:
        "    Yes, ICICI offers lifetime free options, such as the ICICI Amazon Pay Card, which comes with zero joining and annual fees and attractive cashback rewards.",
    },
    {
      question: " How long does it take to get an ICICI credit card approved?",
      answer:
        "If all documents are in order, approval may take 3–5 working days, with card delivery in 7–10 days. Instant virtual cards may be issued in some cases.",
    },
  ];

  const steps = [
    {
      icon: <FaCheckCircle className="h-6 w-6 text-orange-500" />,
      title: "Check Eligibility",
      description:
        "   Use the eligibility section on our platform to cross-reference your income, credit score, and profile with the criteria of different ICICI cards before applying.",
    },
    {
      icon: <FaIdCard className="h-6 w-6 text-green-500" />,
      title: "Organize Your Documents",
      description:
        "  Ensure you have all required KYC and income documents handy. Scanned versions are typically needed for uploading during the online application process.",
    },
    {
      icon: <FaExternalLinkAlt className="h-6 w-6 text-purple-600" />,
      title: "Apply via ICICI Bank’s Official Page",
      description:
        " Once you finalize a card, click on “Apply Now.” You’ll be securely redirected to the ICICI Bank credit card application portal where you can complete the formal process.",
    },
    {
      icon: <FaListAlt className="h-6 w-6 text-teal-500" />,
      title: "Explore & Compare with TheFinMaster",
      description:
        "  Visit TheFinMaster and browse our curated list of ICICI Bank credit cards. We provide detailed breakdowns of each card’s benefits, charges, rewards structure, and ideal usage type—helping you find the one that fits your financial needs.",
    },
  ];
  return (
    <>
      <Helmet>
        <title>
        ICICI Bank Credit Cards – Best Deals & Apply Instantly
        </title>
        <meta
          name="description"
          content="Discover ICICI Bank credit cards with cashback, EMI & rewards. Compare and apply online instantly."
        />
        <meta
          name="keywords"
          content="icici bank credit card, amazon pay icici credit card, forex card icici bank, customer care no icici credit card, icici credit card pay"
        />
        <link
          rel="canonical"
          href="https://thefinmaster.com/icici-bank/credit-card"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      <div className="w-full flex justify-center items-center px-4 mt-20">
  <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
  <AdBanner displayOrder="1" />
  </div>
</div>
      <div className="w-full flex flex-col items-center ">
        <div className="w-full flex flex-col items-center ">
          <div className=" mt-10 w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600">
            <h1 className="text-white text-4xl md:text-7xl text-center font-medium">
              ICICI Bank Credit Cards
            </h1>
            <p className="text-gray-200 text-lg md:text-2xl pt-2 px-4 text-center">
              Experience financial freedom and flexibility with our credit card
              options.
            </p>
          </div>
        </div>
        <div className="flex justify-center items-center  p-4 ">
          <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center mt-4">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
              Explore ICICI Bank’s Range of Versatile and Reward-Driven Credit
              Cards
            </h2>

            <p className="text-gray-600 leading-relaxed mt-3">
              ICICI Bank offers one of the most robust and reliable credit card
              portfolios in India, catering to a wide variety of users—from
              first-time credit card holders to high-spending premium customers.
              Known for their transparent fee structures, accelerated reward
              programs, and unmatched partnerships with global brands, ICICI
              credit cards are a great blend of utility and prestige.
            </p>
          </div>
        </div>
        <h2 className="text-center text-2xl md:text-3xl font-bold text-gray-800 my-10">
          Featured Credit Cards
        </h2>
        <div className="w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center mb-10">
          <div className="w-fit flex flex-col gap-8">
            {currentCards &&
              currentCards.map((item, index) => {
                return (
                  <>
                    {" "}
                    <CardComponent
                      key={index}
                      cardDetails={item}
                      Card_features={item?.Card_features}
                      fees={item?.fees}
                      cardName={item?.title}
                      cardImage={item?.image}
                      rating={item?.rating}
                      category={item?.category}
                      status={item?.status}
                      bank_link={item?.bank_link}
                    />{" "}
                  </>
                );
              })}
          </div>

         <div className="w-full relative ">
                                      <div className="sticky overflow-hidden top-20 w-full h-[500px] flex flex-col justify-between">
                                        {/* <div className="w-[70%] mx-auto">
                                          <h2 className="text-center font-medium pt-5 text-lg">
                                            <span className="font-semibold text-white">816 people</span>{" "}
                                            are on call with our advisors right now
                                          </h2>
                                        </div> */}
                                        <div className="w-full mx-auto">
                                      
                                            <div className="w-[80%] mx-auto ">
                                            <AdBanner displayOrder="2" />
                                            </div>
                                       
                                          <div className="bg-white">
                                            {/* <h3 className="text-center text-blue-500 cursor-pointer font-semibold py-2">
                                              Know your advisor
                                            </h3> */}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    </div>
        {/* Pagination */}
        <ul className="flex justify-center mt-4">
          {currentCards &&
            CreditCardData.cards?.filter(
              (card) => card.category === "Credit card"
            ).length > 0 &&
            Math.ceil(
              CreditCardData.cards?.filter(
                (card) => card.category === "Credit card"
              ).length / cardsPerPage
            ) > 1 &&
            Array.from({
              length: Math.ceil(
                CreditCardData.cards?.filter(
                  (card) => card.category === "Credit card"
                ).length / cardsPerPage
              ),
            }).map((_, index) => (
              <li key={index} className="mx-1">
                <button
                  className={`px-3 py-1 rounded-lg ${
                    currentPage === index + 1
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-gray-800"
                  }`}
                  onClick={() => paginate(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
        </ul>

        {/* <div className='w-[95%] py-10'>
                           <h1 className='text-center font-bold text-5xl my-10'>Frequently Asked Questions</h1>
                           <AccordionComponent />
                       </div> */}

        <div className="w-full px-2 py-2 bg-gradient-to-br from-sky-50 via-white to-sky-100 dark:from-gray-900 dark:to-gray-800">
          <div className="max-w-6xl mx-auto grid gap-10">
            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-sky-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <FileText className="w-8 h-8 text-sky-600" />
                <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                  Eligibility Criteria to Apply for ICICI Bank Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Age Requirement
                  </span>
                  <span>
                    {" "}
                    The primary cardholder must be between 21 and 65 years old.
                    Add-on cardholders should be a minimum of 18 years.{" "}
                  </span>
                </div>

                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Minimum Income
                  </span>
                  <span>
                    {" "}
                    ICICI Bank credit cards generally require a monthly income
                    of ₹15,000 or more. Premium cards may require higher income
                    brackets based on features and rewards.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Credit Score
                  </span>
                  <span>
                    {" "}
                    A CIBIL score of 700 or above is highly recommended. A
                    stronger credit profile improves the likelihood of approval
                    and may unlock better credit limits.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Employment Type
                  </span>
                  <span>
                    {" "}
                    Both salaried and self-employed individuals are eligible.
                    Applicants should show proof of stable employment or
                    business continuity.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Residential Status
                  </span>
                  <span>
                    {" "}
                    The applicant must be an Indian resident with a valid
                    residential address and required KYC documentation.
                  </span>
                </div>
              </div>
            </div>

            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-emerald-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <BadgeCheck className="w-8 h-8 text-emerald-600" />
                <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                  Documents Required to Apply for ICICI Bank Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Proof of Identity
                  </span>
                  <span>
                    {" "}
                    Government-approved photo ID such as PAN Card, Aadhaar Card,
                    Passport, or Voter ID is required for KYC verification.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Proof of Address
                  </span>
                  <span>
                    {" "}
                    Submit recent utility bills, passport, rental agreement, or
                    Aadhaar Card to verify your current residential address.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Proof of Income
                  </span>
                  <span>
                    {" "}
                    Salaried individuals: Provide last 3 months’ salary slips
                    and bank account statements. Self-employed: Submit latest
                    ITR filings, business proof, and audited financials as
                    applicable.{" "}
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Recent Passport-Size Photograph
                  </span>
                  <span>
                    {" "}
                    A colored passport-sized photograph must be submitted as
                    part of the application.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl sm:col-span-2">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Pan Card
                  </span>
                  <span>
                    {" "}
                    PAN is compulsory for all applicants and is used to check
                    financial and tax records with credit history.{" "}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full flex justify-center items-center my-6 px-4">
          <div className="w-full max-w-[984px]">

     
        <AdBanner displayOrder="3" />
        </div>
         
        </div>
      <div className="px-4 py-10 md:px-8 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 text-center mb-4">
          How to Apply for ICICI Bank Credit Card
        </h2>
        {/* <p className="text-gray-600 text-sm md:text-base mt-2 text-center mb-8">
                     Applying for a fuel credit card is a seamless process that starts with
                     the right research and ends at the official bank’s platform for final
                     submission. Here’s how you can get started through TheFinMaster.com:
                   </p> */}
        <div className="grid gap-6 md:grid-cols-2">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="flex items-start gap-4 p-4 rounded-xl bg-white dark:bg-gray-900 shadow-md border hover:shadow-lg transition"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="mt-1">{step.icon}</div>
              <div>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-1">{`${
                  index + 1
                }. ${step.title}`}</h3>
                <p className="text-md text-gray-600 dark:text-gray-300">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      <div className="max-w-4xl mx-auto py-6 px-2">
        <h2 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ICICI;
